import { render } from "./IncomingOrder.vue?vue&type=template&id=2410fb4d&scoped=true"
import script from "./IncomingOrder.vue?vue&type=script&lang=js"
export * from "./IncomingOrder.vue?vue&type=script&lang=js"

import "./IncomingOrder.vue?vue&type=style&index=0&id=2410fb4d&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2410fb4d"]])

export default __exports__